module.exports = __webpack_public_path__ + "img/main.73c9bc54.png";